import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const apiGet = (path, params) =>
  axios.get(`${API}${path}`, { headers: authHeaders(), params }).then((r) => r.data);

/** GET/POST a file and hand it to the browser. Returns the filename used. */
export async function downloadFile(path, fallbackName, { method = 'get', params } = {}) {
  const config = { headers: authHeaders(), responseType: 'blob', params };
  const res = method === 'post'
    ? await axios.post(`${API}${path}`, {}, config)
    : await axios.get(`${API}${path}`, config);
  const disposition = res.headers?.['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const filename = match ? match[1] : fallbackName;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return filename;
}

/**
 * Clipboard write that reports failure instead of pretending. The async
 * Clipboard API is missing on plain-http origins, so fall back to a hidden
 * textarea + execCommand before giving up.
 */
export async function copyText(text) {
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to the legacy path */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
